import glamorous from 'glamorous'

import { hexToRgb } from '../../../helpers/styles'

import * as colours from '../../../styles/colours'
import * as fonts from '../../../styles/typography'

export const StyledForgotForm = glamorous.div({
  width: '100%',
  maxWidth: 620,
  overflow: 'hidden',
  margin: '40px 0',
  background: `${colours.white}`,
  boxShadow: `0 10px 50px 0 rgba(${hexToRgb(colours.shadow)}, 0.2)`,
})

export const StyledForgotMessage = glamorous.div({
  width: '100%',
  overflow: 'hidden',
  padding: '10px 80px 10px',
  background: colours.white,
  color: colours.basicBlMain,
  fontFamily: fonts.fontRegular,
  fontWeight: 200,
  fontSize: 16,
})

export const StyledForgotSuccessMessage = glamorous.div({
  width: '100%',
  overflow: 'hidden',
  padding: '20px 80px 60px',
  textAlign: 'center',
  background: colours.white,
  color: colours.basicBlMain,
  fontFamily: fonts.fontMedium,
  fontWeight: 200,
  fontSize: 16,
})



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/ForgotForm/ForgotForm.glamorous.tsx